const RoutingKeys = {
/*
*  !!!!!!!!!!!!!!!!!!!!!! Autogenerated file, source: RoutingKeys.js.vm
*/

    DIALOG_MANAGER_INFO_COMPANY_EXIST: "dialog_manager_info_company_exist",
    DIALOG_MANAGER_INFO_INSERT_NEW_NAME_OF_ORGANIZATION: "dialog_manager_info_insert_new_organization",
    DOCUMENT_BASE_COMPANIES: "document_base_companies",
    DOCUMENT_SUPPLIERS: "document_suppliers",
    IMAGES_LIMIT_EXCEEDED: "imagesLimitExceeded",
    INSERT_COMPONENT_INDEX_FORM: "insert_component_index_form",
    INSERT_COMPONENT_INDEX_GRID: "insert_component_index_grid",
    INSPIRATION_GENERATING_STATE: "inspirationGeneratingState",
    INSPIRATION_IMAGE_LIST_CHANGES: "inspirationImageListChanges",
    INSPIRATION_SELECTED_IMAGES: "inspirationSelectedImages",
    REFRESH_LIST: "refreshList",
    REFRESH_TABS: "refresh_tabs",
    RK_CHAT_CHANGE_OFFER: "chat_change.offer",
    RK_CHAT_CHANGE_OFFER_BASE_COMPANIES: "chat_change_offer_base_company",
    RK_CHAT_CHANGE_OFFER_SUPPLIERS: "chat_change_offer_suppliers",
    RK_CHAT_CHANGE_REFRESH_OFFER_DASHLET_BASE_COMPANIES: "chat_change_refresh_offer_dashlet_base_company",
    RK_CHAT_CHANGE_REFRESH_OFFER_DASHLET_SUPPLIER: "chat_change_refresh_offer_dashlet_supplier",
    RK_CHAT_CHANGE_REFRESH_SAMPLE_DASHLET_BASE_COMPANIES: "chat_change_refresh_sample_dashlet_base_company",
    RK_CHAT_CHANGE_REFRESH_SAMPLE_DASHLET_SUPPLIER: "chat_change_refresh_sample_dashlet_supplier",
    RK_CHAT_CHANGE_SAMPLE: "chat_change.sample",
    RK_CHAT_CHANGE_SAMPLE_BASE_COMPANIES: "chat_change.sample.base_company",
    RK_CHAT_CHANGE_SAMPLE_SUPPLIERS: "chat_change.sample.suppliers",
    RK_PRESTA_SHOP_INTEGRATION_STATUS: "presta_shop_integration_status",
    RK_SUBIEKT_INTEGRATION_STATUS: "subiekt_integration_status",
    RK_SUBSCRIPTIONS_CHANGE: "subscriptions_change",
    UNSEEN_LIST_NOTIFICATION: "unseenListNotification",
}

export default RoutingKeys;
